export default __webpack_public_path__ + "static/media/ecommerce-laptop-side.8128a388.webp";